import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import { ITabItem } from 'components/tab';
import React from 'react';
import InfoContainer from './infoContainer';

const InfoPanel = (props) => {
  const tabItems: ITabItem[] = [
    {
      content: <InfoContainer />,
    },
  ];
  return (
    <div id="searchandfilter-infopanel-wrapper">
      <BaseSidePanel tabItems={tabItems} headerTitle={'Information'} />
    </div>
  );
};

export default InfoPanel;
